/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import PropTypes from 'prop-types';

import * as Layout from '@components/screen/Layout';
import Table from '@components/table/Table';
import SociollaText from '@components/sociolla/SociollaText';

import { isWeb, fullHeight } from '@global/screens';
import { convertDecimal } from '@global/helpers';

import { Dashboard } from '@api/dashboard';

const propTypes = {
  data: PropTypes.array,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onBack: PropTypes.func,
};

const defaultProps = {
  data: [],
  style: {},
  onBack: () => {},
};

const tableStructure = {
  brand: {
    head: 'Brand',
    body: 'brand.name',
    rowSpan: 2,
  },
  ytd_bio: {
    head: 'YTD Bio (IDR)',
    body: 'ytd',
    rowSpan: 2,
    type: 'currency-number',
  },
  contribution: {
    head: '& Contrib.',
    body: 'contribution',
    rowSpan: 2,
  },
  mtd_bio: {
    head: 'MTD Bio (IDR)',
    body: 'mtd',
    colSpan: 12,
    top: true,
  },
  jan: {
    head: 'Jan',
    body: 'Jan',
    type: 'currency-number',
  },
  feb: {
    head: 'Feb',
    body: 'Feb',
    type: 'currency-number',
  },
  mar: {
    head: 'Mar',
    body: 'Mar',
    type: 'currency-number',
  },
  apr: {
    head: 'Apr',
    body: 'Apr',
    type: 'currency-number',
  },
  may: {
    head: 'May',
    body: 'May',
    type: 'currency-number',
  },
  jun: {
    head: 'Jun',
    body: 'Jun',
    type: 'currency-number',
  },
  jul: {
    head: 'Jul',
    body: 'Jul',
    type: 'currency-number',
  },
  aug: {
    head: 'Aug',
    body: 'Aug',
    type: 'currency-number',
  },
  sep: {
    head: 'Sep',
    body: 'Sep',
    type: 'currency-number',
  },
  oct: {
    head: 'Oct',
    body: 'Oct',
    type: 'currency-number',
  },
  nov: {
    head: 'Nov',
    body: 'Nov',
    type: 'currency-number',
  },
  dec: {
    head: 'Dec',
    body: 'Dec',
    type: 'currency-number',
  },
};

const SalesBrand = (props) => {
  const { onBack } = props;
  const [tableData, setTableData] = useState([]);

  // const examples = [
  //   {
  //     brand: { name: 'Ariul' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'COSRX' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'Senka' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'Gils' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'Mediheal' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  //   {
  //     brand: { name: 'A`pieu' },
  //     ytd_bio: 10000,
  //     contribution: '20%',
  //     jan: 200,
  //     feb: 300,
  //     mar: 23,
  //     apr: 350,
  //     may: 354,
  //     jun: 320,
  //     jul: 222,
  //     aug: 344,
  //     sep: 102,
  //     oct: 100,
  //     nov: 123,
  //     dec: 400,
  //   },
  // ];

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getData();
    }
    return () => {
      mounted = false;
    };
  }, []);

  const getData = async () => {
    try {
      const response = await Dashboard.getDashboardData(
        'sales-value',
        'brand',
        {
          params: {
            filter: {
              see_more: true,
            },
          },
        },
      );
      if (response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          const final = {};
          const obj = Object.keys(item);
          for (let i = 0; i < obj.length; i++) {
            const key = obj[i];
            if (key == 'contribution') {
              let value = item[key];
              if (item[key]) {
                const finalVal = convertDecimal(item[key], 2);
                if (item[key].toString().indexOf('%') > -1) {
                  value = finalVal;
                } else {
                  value = `${finalVal}%`;
                }
              }
              final[key] = value;
            } else {
              final[key] = item[key];
            }
          }
          return final;
        });
        setTableData(result);
      } else {
        setTableData([]);
      }
    } catch (err) {
      console.log('err-sales-brand', err);
    }
  };

  return (
    <>
      {isWeb && <Layout.Back title="Dashboard" onCallback={() => onBack()} />}
      <Layout.Wrapper fullWidth rounded>
        <View style={styles.container}>
          <SociollaText type="medium" style={styles.titlePage}>
            Sales Brand - MTD
          </SociollaText>
          <ScrollView
            horizontal
            style={styles.scrollHorizontal}
            contentContainerStyle={styles.scrollHorizontal}>
            <ScrollView style={{ maxHeight: fullHeight - 230 }}>
              <Table
                structures={tableStructure}
                data={tableData}
                loading={false}
                searchKey="name"
                searchPlaceholder="Search by brand name..."
                hasCallback={true}
                hasNoHide={true}
                showFilter={false}
                showPagination={false}
                showSearch={false}
                onClickRow={({ data }) => {
                  console.log('detail', data);
                }}
                onSearch={() => {
                  console.log('search');
                }}
                totalData={0}
                // skip={paramsState.skip}
                // limit={paramsState.limit}
              />
            </ScrollView>
          </ScrollView>
        </View>
      </Layout.Wrapper>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 15,
  },
  scrollHorizontal: { width: '100%' },
  titlePage: {
    fontSize: 20,
    marginBottom: 15,
  },
});

SalesBrand.propTypes = propTypes;
SalesBrand.defaultProps = defaultProps;

export default React.memo(SalesBrand, (prev, next) => prev == next);
